<template>
    <div class="login-page-wrapper aboutpage" :class="{'bodyfont-unauth': !user}">
        <div class="over-lay"></div>
        <div class="container">
            <div class="row aboutrow">
                <div class="col-md-12">
                    <div class="main-content">
                        <h2 class="heading" v-if="messageHeader"><strong>{{messageHeader}}</strong></h2>
                    </div>
                </div>
                <div class="col-md-12">
                    <h3 v-if="messageText" v-html="messageText">
                        <!--We expect to be up in a couple of hours. Through this time, you can find our upcoming events, articles, and inspiration on <strong><a href="facebook.com/tonenetworks" target="_blank">facebook.com/tonenetworks</a></strong>. Thanks for your patience!-->
                    </h3>
                    <img v-if="messageImageUrl" :src="messageImageUrl" />
                    <br>
                    <br>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { input, spinner, alert } from 'vue-strap'
    import { mapGetters } from 'vuex'
    import slick from 'slick-carousel'
    import $ from 'jquery'

    export default {
        components: {
            'bs-input': input,
            'spinner': spinner,
            'alert': alert
        },
        name: 'login',
        data: function () {
            return {
                success: false,
                successMsg: '',
                contactForm: {
                    emailAddress: '',
                    phoneNumber: '',
                    reason: '',
                    comments: ''
                },
                spinner: false,
                staffMembers: null,
                showMembers: false,
                messageHeader: '',
                messageText: '',
                messageImageUrl: ''
            }
        },
        computed: {
            ...mapGetters([
                'error', 'user', 'getMembers', 'getAllSiteContents', 'getSiteStatus'
            ])
        },
        methods: {
            spinnerToggle () {
                this.spinner = !this.spinner
            },
            onSubmit () {
                if (this.contactForm.emailAddress && this.contactForm.phoneNumber) {
                    this.spinnerToggle()
                    this.$store.dispatch('SENDCONTACTUSFORM', this.contactForm).then(() => {
                        this.success = true
                        this.successMsg = 'Your message has been sent, we will get back to you shortly!'
                        this.spinnerToggle()
                    })
                }
            },
            setCarousal () {
                $.slick = slick
                const $slick = $(this.$el).find('.responsive-slick-imagelist')
                $slick.each(function () {
                    $slick.slick({
                        dots: false,
                        infinite: false,
                        speed: 300,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        responsive: [{
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                infinite: true,
                                dots: false
                            }
                        }, {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }, {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }]
                    })
                })
            },
            setDynamicSection (coll, key) {
                let valCol = coll.filter(x => {
                    return x.content_id === key
                })
                if (valCol && valCol.length > 0) {
                    return valCol[0].content_value
                } else {
                    return ''
                }
            }
        },
        watch: {
//            'staffMembers' (to, from) {
//                let self = this
//                if (self.staffMembers && self.staffMembers.length > 0) {
//                    setTimeout(() => {
//                        self.showMembers = true
//                        self.setCarousal()
//                    }, 1000)
//                }
//            }
        },
        mounted: function () {
            let self = this
            this.$store.dispatch('GETAPPCONFIGRATION').then(() => {
                if (!self.getSiteStatus) {
                    self.$router.push('/')
                }
            })
            self.$store.dispatch('GETDYNAMICCONTENTS', 13).then(() => {
                if (self.getAllSiteContents) {
                    // How we Begin Section
                    self.messageHeader = this.setDynamicSection(this.getAllSiteContents, 'LINE_01')
                    self.messageText = this.setDynamicSection(this.getAllSiteContents, 'LINE_02')
                    self.messageImageUrl = this.setDynamicSection(this.getAllSiteContents, 'IMAGE_URL_01')
                }
            })
            self.$store.dispatch('CACHEPAGE', window.location.href)
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h2.heading {
        color: #f0617d;
        text-transform: capitalize;
        margin: 47px 0 35px 0;
        letter-spacing: 0.5px;
        font-family: sans-serif;
        font-size: 30px;
    }
    .aboutlogoholder {
        min-height: 300px;
        line-height: 300px;
    }

    .mtop30 {
        margin-top: 30px;
    }

    .row.aboutrow p {
        font-size: 17px;
        text-align: left;
        line-height: 1.5;
        letter-spacing: 2px;
    }
    h3 {
        color: #f0617d;
        letter-spacing: 2px;
        font-size: 24px;
        line-height: 1.5;
        margin: 30px 0 20px;
    }
    h4 {
        color: #f0617d;
        letter-spacing: 4px;
        font-size: 22px;
        text-align: left;
        line-height: 1.5;
    }
    h4.welcomemessage {
        text-align: center;
        margin: 50px 0 0;
        color: inherit;
        color: #f0617d;
    }

    h2.welcomemessage {
        letter-spacing: 8px;
        margin: 20px 0 60px;
        text-transform: uppercase;
    }
    .slide-player img {
        max-width: 100%;
    }
    @media(max-width:480px){
        body h4 {
            font-size: 18px !important;
        }

        h3 {
            font-size: 24px !important;
            line-height: 1.1 !important;
        }

        h2.welcomemessage {
            letter-spacing: 3px !important;
        }
    }
    html .slide-player {
        padding: 0 10px;
        margin: 0;
    }
    h2.heading strong {
        font-weight: 700;
    }

    h3 a {
        text-decoration: underline;
        word-wrap: break-word;
    }

    img {
        max-width: 100%;
    }



</style>
<style>
    .aboutpage .slider.responsive-slick-imagelist.slick-initialized.slick-slider .slick-list {
        z-index: 0;
    }

    .aboutpage .slider.responsive-slick-imagelist.slick-initialized.slick-slider button {
        z-index: 50;
    }
    html .aboutpage .slide-player p{
        margin:0 0 10px;
        color: #a7a7a7;
        font-size: 18px;
    }
</style>



// WEBPACK FOOTER //
// Maintainance.vue?2b3a973a